import { combineReducers } from 'redux'
// import { routerReducer } from 'react-router-redux'

import user from './user'
import brands from '../modules/Brands/redux/brands'
import cities from '../modules/Cities/redux/cities'
import clusters from '../modules/Clusters/redux/clusters'
import kitchens from '../modules/Kitchens/redux/kitchens'
import stores from  '../modules/Stores/redux/stores'

import orders from '../modules/OrdersTable/redux/orders'
import orderStatistics from '../modules/OrdersTable/redux/order_statistics'
import sellers from '../modules/Sellers/redux/sellers'
import dailyMenus from '../modules/DailyMenus/redux/dailymenus'
import products from '../modules/Products/redux/products'
import kits from '../modules/Kits/redux/kits'
import customers from '../modules/Customers/redux/customers'
import privileges from '../modules/Privileges/redux/privileges'
import companies   from '../modules/Companies/redux/companies'
import products_stocks   from '../modules/ProductsStocks/redux/products_stocks'
import wabox from '../modules/Wabox/redux/wabox'
import orderGroups from '../modules/OrderGroups/redux/ordergroups'
import employees from '../modules/Employees/redux/employees'
import roles from '../modules/Roles/redux/roles'
import designations from '../modules/Designations/redux/designations'
import reasons from '../modules/Reasons/redux/reasons'
import costCenters from '../modules/Cost Centers/redux/costCenters'
import departments from '../modules/Departments/redux/departments'
import workLocations from '../modules/Work Locations/redux/workLocations'
import teams from '../modules/Teams/redux/teams'
import hr from '../modules/HR/redux/hr'
import streports from '../modules/ST Reports/redux/streports'
import departmentTeams from '../modules/Department Teams/redux/departmentTeams'
import employeesmovement from '../modules/Employees Movement/redux/employeesmovement'
import categories from '../modules/Categories/redux/categories'
import menus from '../modules/Menus/redux/menus'
import menu_disabled_tickets from '../modules/Menu Disabled Tickets/redux/menu_disabled_tickets'
import kitchen_staffs from '../modules/Kitchen Staffs/redux/kitchen_staffs'
import users from '../modules/Users/redux/users'
import employee_depute from '../modules/Employee Depute/redux/employee_depute'
import employee_rehire from '../modules/Employee Rehire/redux/employee_rehire'
import employee_promotion from '../modules/Employee Promotion/redux/employee_promotion'
import attendances from '../modules/Attendance/redux/attendances'
import order_verification from '../modules/Order Verification/redux/order_verification'
import attendance_cycles from '../modules/Attendance Cycles/redux/attendance_cycles'
import employee_pay_scales from '../modules/Employee Pay Scales/redux/employee_pay_scales'
import entity_types from '../modules/Entity Types/redux/entity_types'
import entity_status from '../modules/Entity Status/redux/entity_status'
import platforms from '../modules/Platforms/redux/platforms'
import attendance_summary from '../modules/Attendance Summary/redux/attendance_summary'
import newjoinee from '../modules/New Joinee/redux/newjoinee'
import assets from '../modules/Assets/redux/assets'
import assetTypes from '../modules/Asset Types/redux/assetTypes'
import assetVendors from '../modules/Asset Vendors/redux/assetVendors'
import assetLocations from '../modules/Asset Locations/redux/assetLocations'
import equipments from '../modules/Equipments/redux/equipments'











export default combineReducers({
  // routing: routerReducer,
  user,
  brands,
  cities,
  clusters,
  kitchens,
  stores,
  orders,
  sellers,
  dailyMenus,
  products,
  kits,
  products_stocks,
  customers,
  companies,
  wabox,
  orderGroups,
  orderStatistics,
  privileges,
  employees,
  roles,
  designations,
  reasons,
  costCenters,
  departments,
  workLocations,
  teams,
  hr,
  streports,
  departmentTeams,
  employeesmovement,
  categories,
  menus,
  menu_disabled_tickets,
  kitchen_staffs,
  users,
  employee_depute,
  employee_rehire,
  employee_promotion,
  attendances,
  order_verification,
  attendance_cycles,
  employee_pay_scales,
  entity_types,
  entity_status,
  platforms,
  attendance_summary,
  newjoinee,
  assets,
  assetTypes,
  assetVendors,
  assetLocations,
  equipments
  
})


// WEBPACK FOOTER //
// ./src/redux/reducer.js